<template>
  <ModalBase :show-modal="showModal" :auto-h="true" narrow @close-modal="close" class="gk-modal-copy-invoice">
    <template v-slot:titlebar>
      <TitleBar variant-class="title-modal">
        <template v-slot:pretitle>
          {{ $gettext('COPY') }}
        </template>
        <template v-slot:title>
          {{ $gettext('Invoice') }} {{ invoice.number }}
        </template>
      </TitleBar>
    </template>
    <template v-slot:maincontent>
      <div v-if="addNewProject">
        <h3>{{ $gettext('Add new customer or project') }}</h3>
        <AddProjectSimple ref="addeditproject" @created="customerProjectCreated" />
      </div>
      <div v-else>
        <p>{{ $gettext('Select a customer or project to copy this invoice to.') }}</p>
        <CustomerSelect @selected-customer="selectCustomerAndProject" with-projects searchable :preselect="preselectedCustomer" />

        <!-- TODO Finish add new customer / project -->
        <p>
          <GekkoButton 
            @click="addNewProject = true"
            :text="$gettext('New project (or customer)? Create it first')" 
            variant="link"
            class="px-0 text-blue"
          />
        </p>
      </div>
    </template>
    <template v-if="addNewProject" v-slot:actions>
      <GekkoButton
        @click="addNewProject = false"
        :text="$gettext('Back')"
        variant="light"
      />
      <GekkoButton
        @click="$refs.addeditproject.saveForm()"
        :text="$gettext('Save')"
      />
    </template>
    <template v-else v-slot:actions>
      <GekkoButton
        @click="close()"
        :text="$gettext('Cancel')"
        variant="light"
      />
      <GekkoButton
        @click="confirm()"
        :disabled="!selectedCustomer"
        :text="$gettext('Copy')"
      />
    </template>
  </ModalBase>
</template>

<script>
import ModalBase from "@/components/base_components/ModalBase";
import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton";
import AddProjectSimple from "@/components/contacts/AddProjectSimple"
import CustomerSelect from "@/components/invoices/ui/CustomerSelect"

export default {
  name: 'InvoiceCopyModal',
  components: { ModalBase, TitleBar, GekkoButton, AddProjectSimple, CustomerSelect },
  props: {
    invoice: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      showModal: true,
      selectedCustomer: null,
      addNewProject: false
    }
  },
  computed: {
    preselectedCustomer () {
      const preselect = { name: '', customer_id: null, project_id: null }
      if (this.invoice.recipient_customer) {
        preselect.customer_id = this.invoice.recipient_customer.id
        preselect.name = this.invoice.recipient_customer.name
      }
      if (this.invoice.project) {
        preselect.project_id = this.invoice.project.id
        preselect.name = this.invoice.project.name
      }
      return preselect
    }
  },
  mounted () {
    document.body.classList.add('modal-on')
  },
  methods: {
    close () {
      this.$emit('close')
    },
    selectCustomerAndProject (selected) {
      if (selected.customer_id) {
        this.selectedCustomer = selected
      } else {
        this.selectedCustomer = null
      }
    },
    customerProjectCreated (customer_project) {
      if (customer_project.id && customer_project.company) {
        this.selectedCustomer = { customer_id: customer_project.company, project_id: customer_project.id }
        this.confirm()
      }
    },
    confirm () {
      if (this.selectedCustomer) {
        this.$emit('selected-customer', this.selectedCustomer)
      }
    }
  }
}
</script>

<style lang="scss">
.gk-modal-copy-invoice {
  .gk-modal {
    max-width: 530px !important;
    .action-buttons-wrapper {
      display: flex;
      gap: 0.75rem;
      justify-content: flex-end;
    }
  }
}
</style>